var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgSmileBeautifySlashOutlineShadowLarge48 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "currentColor",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M5.854 11.132a1.263 1.263 0 1 0 0-2.527 1.263 1.263 0 0 0 0 2.527Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M1.19 1.731a.79.79 0 0 1 1.117 0l16.42 16.421a.79.79 0 0 1-1.116 1.117l-1.983-1.983A8.842 8.842 0 0 1 3.173 4.83L1.19 2.848a.79.79 0 0 1 0-1.117Zm11.378 12.495 1.938 1.938A7.263 7.263 0 0 1 4.295 5.953l7.35 7.35a4.143 4.143 0 0 1-1.686.336c-.952 0-1.53-.262-1.93-.443-.365-.166-.582-.264-.798-.036-.455.479.454 2.393 2.728 2.393 1.353 0 2.222-.678 2.61-1.327Z",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M6.82 3.949a7.263 7.263 0 0 1 9.691 9.691.79.79 0 1 0 1.423.683A8.842 8.842 0 0 0 6.136 2.525a.79.79 0 0 0 .683 1.424Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M15.327 9.868a1.263 1.263 0 1 1-2.526 0 1.263 1.263 0 0 1 2.526 0Z"
})));
export { SvgSmileBeautifySlashOutlineShadowLarge48 as ReactComponent };